module.exports = __webpack_public_path__ + "static/img/register_patient_by_doctor.8f2388c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register_patient_by_doctor.jpg
// module id = +Emz
// module chunks = 7